'use client';
import styles from './styles.module.css';

import React, { useEffect, useRef, useState } from 'react';

interface ViewportWrapperProps {
  children: React.ReactNode;
  className?: string;
  triggerOffset?: number; // Pixels from the bottom of the viewport to trigger the animation
  delay?: number | string;
}

const ViewportWrapper: React.FC<ViewportWrapperProps> = ({
  children,
  className = '',
  triggerOffset = 100,
  delay = 0,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const componentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (componentRef.current) {
        const rect = componentRef.current.getBoundingClientRect();
        const isElementInView =
          rect.top - window.innerHeight + triggerOffset < 0 && rect.bottom >= 0; // Check if the element is at least partially in view

        if (isElementInView && !isVisible) {
          setIsVisible(true);
        }
      }
    };
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      window.addEventListener('scroll', handleScroll);
      handleScroll(); // Check on initial load
    }

    return () => {
      typeof window !== 'undefined' &&
        typeof document !== 'undefined' &&
        window.removeEventListener('scroll', handleScroll);
    };
  }, [isVisible, triggerOffset]);

  const [finished, setFinished] = useState(false);

  return (
    // <div
    //   ref={componentRef}
    //   className={`${className} ${styles.revealWrapper} ${isVisible ? styles.visible : ''}`}
    //   style={{ transitionDelay: `${delay}s` }}
    // >
    //   {children}
    // </div>

    // <div ref={componentRef} className={className}>
    //   <div
    //     className={`${styles.revealContent} ${isVisible ? styles.visible : ''}`}
    //     style={{ transitionDelay: `${delay}s` }}
    //   >
    //     {children}
    //   </div>
    // </div>

    <div
      ref={componentRef}
      className={`${className} ${styles.revealWrapper} ${
        isVisible ? styles.visible : ''
      } ${finished ? styles.finished : ''}`}
      onTransitionEnd={() => setFinished(true)}
      style={{ transitionDelay: `${delay}s` }}
    >
      {children}
    </div>
  );
};

export default ViewportWrapper;
